import React from "react";
import Navbar from "../Navbar/Navbar";
import Middlebartimeline from "./Middlebartimeline";

const Timeline = () => {
  return (
    <div>
      <Navbar />
      <Middlebartimeline />
    </div>
  );
};

export default Timeline;
